import { Button, Card, Checkbox, Collapse, CollapseProps, ConfigProvider, Form, Image, Input, Radio, Typography } from "antd";
import React, { useEffect, useState } from "react";
import Logo from "../../../../assets/images/Logo_250.png";
import { useForm } from "antd/es/form/Form";
import { CaretUpOutlined, CaretDownOutlined, EnvironmentOutlined, ArrowRightOutlined } from "@ant-design/icons";
import "../../css/index.css";
import { UserEventService } from "../../../../api/user.service";
import { useNavigate, useParams } from "react-router-dom";
import { useId24 } from "../../../../drivers/id24/Id24Provider";
import { loadAppConfig } from "../../../../configs/app-config";

export const EconnectDinner: React.FC = (): React.ReactElement => {
  const [formValue] = useForm();
  const [loading, setLoading] = useState<boolean>(true);
  const { agendaid, ticketid } = useParams<{ agendaid: string; ticketid: string }>();
  const { id24Axios } = useId24();
  const navigate = useNavigate();
  const apiBaseUrl = id24Axios(loadAppConfig().REACT_APP_API_BASE_URL);
  const [userData, setUserDate] = useState<{
    userId: "";
    numberId: string;
    dataSource: {
      fullname: string;
      position: string;
      company: string;
      businessEmail: string;
      phoneNumber: string;
      businessType: {
        value: string;
        label: string;
      };
      type: string;
      ticketNumber: string;
    };
  }>({
    userId: "",
    numberId: "",
    dataSource: {
      fullname: "",
      position: "",
      company: "",
      businessEmail: "",
      phoneNumber: "",
      businessType: {
        value: "",
        label: "",
      },
      type: "",
      ticketNumber: "",
    },
  });

  useEffect(() => {
    if (loading) {
      featchData();
    }
  }, [loading]);

  const featchData = async () => {
    if (agendaid && ticketid) {
      const user = await UserEventService(apiBaseUrl).getByEventAndTicket(agendaid, ticketid);
      if (user && user.dataSource.menuCourse) {
        formValue.setFieldValue("Course", user.dataSource.menuCourse.Course);
      }
      setUserDate(user);
      setLoading(false);
    }
  };

  const onFinish = async (event: any) => {
    const data = { ...userData.dataSource, menuCourse: event };
    try {
      if (agendaid) {
        await UserEventService(apiBaseUrl).updateByEvent(userData.userId, data);
        navigate(`/activity-agenda/select-section/${agendaid}/success-dinner`);
        setLoading(true);
      }
    } catch (err) {
      console.log(err);
    }
  };
  return (
    <>
      {/* <div className="w-[353px] h-[653.18px] top-[99px] left-[25px] rounded-[10px] pt-[32px] pr-[26px] pb-[32px] pl-[26px] gap-[32px] "> */}
      <Card className="flex justify-center p-2">
        <Form form={formValue} layout="vertical" autoComplete="off" className="w-full" onFinish={onFinish}>
          <div className="flex justify-center pb-[20px]">
            <Image src={Logo} width={150} preview={false} />
          </div>
          <div className="text-center mt-[5px]">
            <Typography className="font-bold w-full text-[rgba(84,86,90,1)]">{`VIP Dinner Selection Form`}</Typography>
          </div>
          <br />
          <div className=" pb-4">Main Course Selection:*</div>
          <Form.Item name={"Course"} initialValue={"australian-grass-fed-filet-mignon"}>
            <Radio.Group
              options={[
                {
                  value: "australian-grass-fed-filet-mignon",
                  label: (
                    <>
                      <p>
                        <b>Australian Grass-fed Filet Mignon(เนื้อออสเตรเลียกราสเฟด ฟิลเล มิญอง)</b>
                      </p>
                      Served with truffle mashed potato, roasted green vegetables red wine jus.(เสิร์ฟกับมันบดเห็ดทรัฟเฟิล ผักย่าง ซอสไวน์แดง)
                    </>
                  ),
                },
                {
                  value: "snow-fish",
                  label: (
                    <>
                      <p>
                        <b>Snow Fish Mosaic (ปลาหิมะ)</b>
                      </p>
                      Served with thick green curry sauce (ปลาหิมะซูวีซอสแกงเขียวหวาน)
                    </>
                  ),
                },
              ]}
            />
          </Form.Item>
          <p>
            <b>Please specify any allergies or dietary preferences:</b>
          </p>
          <p>(e.g., vegetarian, gluten-free, nut allergy, etc.)</p>
          <br />
          <Form.Item name={"orther"}>
            <Input placeholder="Text" />
          </Form.Item>
          <div className="w-[300px]">
            <Button htmlType="submit" type="primary" className="text-white bg-[rgba(10,78,136,1)] w-full rounded-[5px]" size="large">
              Submit
            </Button>
          </div>
        </Form>
      </Card>
      {/* </div> */}
    </>
  );
};
